import { useState, type FormEvent } from 'react';
import { subscribe } from '@/mocks/chigua';

export default function Subscribe() {
  const [note, setNote] = useState<string | null>(null);
  const [value, setValue] = useState('');

  const onSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setNote('本期为静态展示页，已为您提示，暂未收集任何信息。');
    setValue('');
    window.setTimeout(() => setNote(null), 2600);
  };

  return (
    <section id="subscribe" className="scroll-mt-16 py-12 md:py-16">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <div className="relative overflow-hidden rounded-xl bg-accent-700 px-6 py-10 text-center md:px-12 md:py-14">
          <div className="pointer-events-none absolute -left-10 -top-10 h-40 w-40 rounded-full bg-paper-50/10 blur-2xl" />
          <div className="pointer-events-none absolute -bottom-14 -right-6 h-48 w-48 rounded-full bg-accent-500/40 blur-2xl" />

          <div className="relative mx-auto max-w-2xl">
            <div className="inline-flex items-center gap-2 rounded-full bg-paper-50/15 px-3 py-1.5 text-xs font-medium text-paper-50 backdrop-blur-sm">
              <i className="ri-mail-send-line" />
              {subscribe.kicker}
            </div>
            <h2 className="mt-5 font-heading text-2xl font-bold leading-tight text-paper-50 md:text-4xl">
              {subscribe.title}
            </h2>
            <p className="mx-auto mt-3 max-w-xl text-sm leading-[1.8] text-paper-100/85">
              {subscribe.desc}
            </p>

            <form onSubmit={onSubmit} className="mx-auto mt-7 flex max-w-md flex-col gap-2 sm:flex-row">
              <label htmlFor="mail" className="sr-only">常用邮箱</label>
              <input
                id="mail"
                name="email"
                type="email"
                value={value}
                onChange={(e) => setValue(e.target.value)}
                placeholder={subscribe.placeholder}
                className="w-full flex-1 rounded-md border border-paper-50/25 bg-paper-50/95 px-4 py-3 text-sm text-ink-900 outline-none transition placeholder:text-ink-400 focus:border-paper-50"
              />
              <button
                type="submit"
                className="whitespace-nowrap rounded-md bg-paper-50 px-6 py-3 text-sm font-semibold text-accent-700 transition-colors hover:bg-paper-100"
              >
                订阅提示
              </button>
            </form>

            {note && (
              <p className="mt-4 text-sm text-paper-100/90">
                <i className="ri-checkbox-circle-line mr-1.5 align-[-1px]" />
                {note}
              </p>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}